module.exports = __webpack_public_path__ + "static/media/20.b3a7186c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/20.png
// module id = 1303
// module chunks = 0